import React from 'react'

const PrivacyAndPolicy = () => {
  return (
    <div>
      Privacy And Policy
    </div>
  )
}

export default PrivacyAndPolicy
